import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";

const card2Steps = [
  { key: `card-2.steps-0`, value: "You complete your health intake" },
  {
    key: `card-2.steps-1`,
    value: "A licensed provider reviews your information",
  },
  { key: `card-2.steps-2`, value: "Your personalized plan is created" },
  { key: `card-2.steps-3`, value: "Medication is prepared and shipped" },
  {
    key: `card-2.steps-4`,
    value: "Ongoing care and support continue as you progress",
  },
];

const card3Steps = [
  {
    key: "card-3.step-0",
    value: "Your prescribed medication",
  },
  {
    key: "card-3.step-1",
    value: "Your weekly dose and how to measure it on a syringe",
  },
  {
    key: "card-3.step-2",
    value: "Visual injection guidance",
  },
  {
    key: "card-3.step-3",
    value: "Easy access to your care team",
  },
];

const CareHub = () => {
  const { t } = useTranslation();
  const component = "care-hub";

  return (
    <Stack gap={2}>
      <WhiteCard gap={1}>
        <Typography variant="body2" fontWeight={700} color="#00B6B8">
          {t(`${component}.card-1.header`, "Welcome to Your HolaVida Care Hub")}
        </Typography>
        <Stack>
          <Typography>
            {t(
              `${component}.card-1.text-1`,
              "This page will become your main place to manage your weight-loss care with HolaVida. As you move through your program, everything related to your treatment will live here."
            )}
          </Typography>
          <Typography>
            {t(
              `${component}.card-1.text-2`,
              "Right now, you’re at the beginning - we’ll guide you step by step."
            )}
          </Typography>
        </Stack>
      </WhiteCard>
      <WhiteCard gap={1}>
        <Typography variant="body2" fontWeight={700}>
          {t(`${component}.card-2.header`, "Your HolaVida Journey")}
        </Typography>
        <Typography>
          {t(
            `${component}.card-2.steps-header`,
            "Here’s how the process works from start to finish:"
          )}
        </Typography>
        <Stack gap={1} ml={1} component={"ol"} sx={{ mt: 0, mb: 0, pl: 2 }}>
          {card2Steps.map((step, idx) => (
            <Typography key={idx} component={"li"}>
              {t(`${component}.${step.key}`, step.value)}
            </Typography>
          ))}
        </Stack>
        <Typography>
          {t(
            `${component}.card-2.text`,
            "We’ll notify you as you move through each step."
          )}
        </Typography>
      </WhiteCard>
      <WhiteCard gap={1}>
        <Typography variant="body2" fontWeight={700} color="#FF8175">
          {t(`${component}.card-3.header`, "What You’ll See on This Page")}
        </Typography>
        <Typography>
          {t(
            `${component}.card-3.steps-header`,
            "Once your prescription is approved, this page will automatically update to include:"
          )}
        </Typography>
        <Stack gap={1} ml={1} component={"ul"} sx={{ mt: 0, mb: 0, pl: 2 }}>
          {card3Steps.map((step, idx) => (
            <Typography key={idx} component={"li"}>
              {t(`${component}.${step.key}`, step.value)}
            </Typography>
          ))}
        </Stack>
        <Typography>
          {t(
            `${component}.card-3.text`,
            "You won’t need to search for anything - it will all appear here."
          )}
        </Typography>
      </WhiteCard>
      <WhiteCard gap={1}>
        <Typography variant="body2" fontWeight={700} color="#00B6B8">
          {t(`${component}.card-4.header`, "Support Along the Way")}
        </Typography>
        <Typography>
          {t(
            `${component}.card-4.text-1`,
            "Weight loss is not one-size-fits-all. Your care team is available throughout your journey to answer questions, review progress, and make adjustments when needed."
          )}
        </Typography>
        <Typography>
          {t(`${component}.card-4.text-2`, "Call or text us anytime:")}{" "}
          305-395-5016
        </Typography>
      </WhiteCard>
    </Stack>
  );
};

export default CareHub;
